module.exports = __webpack_public_path__ + "img/logo-ved-sm.1b9dc87e.svg";